import { PayoutType } from 'types';
import { Payout } from 'store/api/payout';
import { formatPrice } from 'utils/helpers';

import { SubRows, SubRow, SubAmount } from 'components/paycheck-dialog/subrows';
import { Card } from './card';
import { signedAmountTypes } from './config';
import { TotalInfoCardProps } from './types';

export const TotalInfoCard = ({
  type,
  title,
  isDeduction,
  selectedValues,
}: TotalInfoCardProps) => {
  const filteredValues = selectedValues.filter((value) => {
    if (value.type !== type) {
      return false;
    }

    if (signedAmountTypes.includes(type)) {
      const amount = Number(value.amount || 0);
      return isDeduction ? amount < 0 : amount > 0;
    }

    return true;
  });

  const { amount, otherEventAdjustments } = filteredValues.reduce(
    (acc, value) => ({
      amount: acc.amount + Number(value.amount || 0),
      otherEventAdjustments: value?.originalEventId
        ? [...acc.otherEventAdjustments, value]
        : acc.otherEventAdjustments,
    }),
    { amount: 0, otherEventAdjustments: [] as Payout[] }
  );

  const formattedAmount = formatPrice(Math.abs(amount));

  if (type === PayoutType.Misc && filteredValues.length) {
    return <div>
      <Card type={type} title={title} isDeduction={isDeduction} value={isDeduction ? `-${formattedAmount}` : formattedAmount} />
      <SubRows>{filteredValues.map(item => (
        <SubRow key={item.id}>
          <span>{item.notes?.trim() ? item.notes : null}</span>
          <SubAmount $negative={Number(item.amount) < 0}>{Number(item.amount) < 0 ? '−' : '+'}{formatPrice(Math.abs(Number(item.amount)))}</SubAmount>
        </SubRow>
      ))}</SubRows>
    </div>;
  }

  return filteredValues.length > 0 ? (
    <Card
      type={type}
      title={title}
      isDeduction={isDeduction}
      otherEventAdjustments={otherEventAdjustments}
      value={isDeduction ? `-${formattedAmount}` : formattedAmount}
    />
  ) : null;
};
